// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: Arial, Helvetica, sans-serif;
  }
  
  .timeline {
    position: relative;
    max-width: 800px;
    margin: 0 auto;
  }
  .timeline:before {
    content: '';
    position: absolute;
    width: 6px;
    background-color: orange;
    top: 40px; /* Start the line below the first stage's top */
    bottom: 0;
    left: 50%;
    margin-left: -3px; /* Center the line */
  }
    
  .timeline-item {
    padding: 20px 40px;
    position: relative;
    width: 50%;
  }
  
  .timeline-item:nth-child(odd) {
    left: 0;
  }
  
  .timeline-item:nth-child(even) {
    left: 50%;
  }
  
  
  
  .timeline-content {
    padding-top: 20px;
    padding-left: 2%;
    padding-right: 2%;
    padding-bottom: 20px;
    background-color: #f9f9f9;
    position: relative;
    border-radius: 6px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 5%;
    margin-top: 5%;
  }
  
  .timeline-content:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  }
  
  .timeline-content h2 {
    margin: 0;
    color: #FF6347;
    flex-wrap: nowrap;
  }
  
  .timeline-content p {
    margin: 10px 0;
  }
  
  .timeline-content strong {
    color: #333;
  }
  .timeline-arrow {
    position: absolute;
    top: 100%; /* Below the content box */
    left: 50%;
    margin-left: -12px;
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 12px solid #a24646; /* Color of the arrow */
    z-index: 2;
  }
  
  /* Hide the arrow on the last item */
  .timeline-item:last-child .timeline-arrow {
    display: none;
  }

  @media screen and (max-width: 650px) {
    .timeline-item {
      width: 100%;
      float: 'center';
      left: 0 !important;
    }
    .timeline-item:nth-child(even) {
      left: 0 !important;
    }
    .timeline:before {
      left: 50%;
    }
    .timeline-content {
      width: calc(100%);
    }
    .timeline-arrow {
      float: 'center';
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/JourneySoFar.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,SAAS,EAAE,+CAA+C;IAC1D,SAAS;IACT,SAAS;IACT,iBAAiB,EAAE,oBAAoB;EACzC;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,SAAS;EACX;;;;EAIA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,qDAAqD;IACrD,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,yCAAyC;EAC3C;;EAEA;IACE,SAAS;IACT,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,SAAS,EAAE,0BAA0B;IACrC,SAAS;IACT,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,8BAA8B,EAAE,uBAAuB;IACvD,UAAU;EACZ;;EAEA,oCAAoC;EACpC;IACE,aAAa;EACf;;EAEA;IACE;MACE,WAAW;MACX,eAAe;MACf,kBAAkB;IACpB;IACA;MACE,kBAAkB;IACpB;IACA;MACE,SAAS;IACX;IACA;MACE,iBAAiB;IACnB;IACA;MACE,eAAe;IACjB;EACF","sourcesContent":["body {\n    font-family: Arial, Helvetica, sans-serif;\n  }\n  \n  .timeline {\n    position: relative;\n    max-width: 800px;\n    margin: 0 auto;\n  }\n  .timeline:before {\n    content: '';\n    position: absolute;\n    width: 6px;\n    background-color: orange;\n    top: 40px; /* Start the line below the first stage's top */\n    bottom: 0;\n    left: 50%;\n    margin-left: -3px; /* Center the line */\n  }\n    \n  .timeline-item {\n    padding: 20px 40px;\n    position: relative;\n    width: 50%;\n  }\n  \n  .timeline-item:nth-child(odd) {\n    left: 0;\n  }\n  \n  .timeline-item:nth-child(even) {\n    left: 50%;\n  }\n  \n  \n  \n  .timeline-content {\n    padding-top: 20px;\n    padding-left: 2%;\n    padding-right: 2%;\n    padding-bottom: 20px;\n    background-color: #f9f9f9;\n    position: relative;\n    border-radius: 6px;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    margin-bottom: 5%;\n    margin-top: 5%;\n  }\n  \n  .timeline-content:hover {\n    transform: scale(1.05);\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  }\n  \n  .timeline-content h2 {\n    margin: 0;\n    color: #FF6347;\n    flex-wrap: nowrap;\n  }\n  \n  .timeline-content p {\n    margin: 10px 0;\n  }\n  \n  .timeline-content strong {\n    color: #333;\n  }\n  .timeline-arrow {\n    position: absolute;\n    top: 100%; /* Below the content box */\n    left: 50%;\n    margin-left: -12px;\n    width: 0;\n    height: 0;\n    border-left: 12px solid transparent;\n    border-right: 12px solid transparent;\n    border-top: 12px solid #a24646; /* Color of the arrow */\n    z-index: 2;\n  }\n  \n  /* Hide the arrow on the last item */\n  .timeline-item:last-child .timeline-arrow {\n    display: none;\n  }\n\n  @media screen and (max-width: 650px) {\n    .timeline-item {\n      width: 100%;\n      float: 'center';\n      left: 0 !important;\n    }\n    .timeline-item:nth-child(even) {\n      left: 0 !important;\n    }\n    .timeline:before {\n      left: 50%;\n    }\n    .timeline-content {\n      width: calc(100%);\n    }\n    .timeline-arrow {\n      float: 'center';\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
